<template>
  <LayoutSection>
    <MainContent paddingClass="p-[2.4rem]">
      <h2
        class="text-[24px] sm:text-[2.4rem] md:text-[3.2rem] font-semibold text-center text-black"
      >
        {{ $t("Well-being tailored to you.") }}
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[1.6rem] pt-[4.8rem]">
        <div
          class="w-full"
          v-for="box in boxes"
          :key="box.id"
        >
          <SubContent paddingClass="pt-[3.2rem] pb-[1.6rem] px-[1.6rem]">
            <img class="w-[7.2rem] relative z-[1]" :src="box.icon" alt="" aria-hidden="true" loading="lazy" decoding="async" />
            <img
              class="absolute w-full left-0 top-0"
              src="@/assets/images/medicina-shape.png"
              alt=""
              aria-hidden="true"
              loading="lazy"
              decoding="async"
            />
            <div class="pt-[7.4rem]">
              <h4
                class="text-black text-[1.6rem] font-medium tracking-[-0.48px]"
              >
                {{ box.title }}
              </h4>
              <p class="max-w-[24.6rem] leading-[1.28] pt-4">
                {{ box.description }}
              </p>
            </div>
          </SubContent>
        </div>
      </div>
    </MainContent>
  </LayoutSection>
</template>

<script>
import MainContent from "@/components/design/mainContent.vue";
import SubContent from "@/components/design/subContent.vue";
import LayoutSection from "@/components/design/layoutSection.vue";

export default {
  name: "MedicineAboutSection",
  components: {
    MainContent,
    SubContent,
    LayoutSection,
  },
  data() {
    return {
      boxes: [
        {
          id: 1,
          icon: require("@/assets/images/icon-1.svg"),
          title: this.$t("Medical care tailored to you"),
          description: this.$t(
            "Access a network of healthcare professionals committed to identifying and treating the root cause of your symptoms"
          ),
        },
        {
          id: 2,
          icon: require("@/assets/images/icon-4.svg"),
          title: this.$t("Your health guide"),
          description: this.$t(
            "Discover experts in physical, mental, and emotional well-being who support you with a personalized approach to improving your quality of life"
          ),
        },
        {
          id: 3,
          icon: require("@/assets/images/icon-3.svg"),
          title: this.$t("Book classes and experiences"),
          description: this.$t(
            "Join guided sessions or take part in transformative experiences to support your physical, mental, and emotional well-being"
          ),
        },
        {
          id: 4,
          icon: require("@/assets/images/icon-2.svg"),
          title: this.$t("We confirm your appointment instantly"),
          description: this.$t(
            "Choose your preferred date and time and confirm your booking without the need for phone calls. Fast, convenient, and efficient"
          ),
        },
        // {
        //   id: 4,
        //   icon: require("@/assets/images/icon-4.svg"),
        //   title: this.$t("SMS reminders"),
        //   description: this.$t(
        //     "We confirm your appointment instantly and send you a reminder by SMS before your appointment."
        //   ),
        // },
      ],
    };
  },
};
</script>

<style scoped>
.medicine_icon_box {
  background: #fcfcfc;
}

.medicine_about_section_inner {
  background: rgba(255, 255, 255, 0.5);
}
</style>
